import React, { ReactElement } from 'react';
import { ClientDto, EntityType } from '../../api/ClientApi';
import { Box, Grid2, Typography } from '@mui/material';
import { ClientTypeSR, EntityTypeSR } from '../../common/Types';
import { formatNumber, mapsSearchUrl, telUrl } from '../../common/Extensions';
import { useAppSelector } from '../../hooks/hooks';
import { isEmployeeFinanceManager } from '../../redux/selectors/employeeSelector';

type ClientInfoExtendedProps = {
    client?: ClientDto;
    clientTotalValue?: number;
};

export default function ClientInfoExtended(props: ClientInfoExtendedProps): ReactElement {
    const { client, clientTotalValue } = props;

    const isFinanceManager = useAppSelector(isEmployeeFinanceManager);

    return (
        <Box sx={{ pl: 3, pt: 2, pr: 2, mb: 5, textAlign: 'start' }}>
            <Grid2 container spacing={0}>
                <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                    <Typography variant="body1" className="info-text">
                        Ime: <span style={{ fontWeight: 'bold' }}>{client?.name}</span>
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6, lg: 3 }}>
                    <Typography variant="body1" className="info-text">
                        Skr. ime: <span style={{ fontWeight: 'bold' }}>{client?.shortName ?? '/'}</span>
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6, lg: 3 }}>
                    {isFinanceManager && (
                        <Typography variant="body1" className="info-text">
                            Vrednost robe kod klijenta:{' '}
                            <span style={{ fontWeight: 'bold' }}>
                                {clientTotalValue ? formatNumber(clientTotalValue) : '/'}
                            </span>
                        </Typography>
                    )}
                </Grid2>
                <Grid2 size={{ xs: 0, md: 0, lg: 12 }} sx={{ height: 15 }} />
                <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                    <Typography variant="body1" className="info-text">
                        {client?.entityType === EntityType.Legal
                            ? 'Jedinstveni broj firme (PIB/JIB...)'
                            : client?.entityType === EntityType.Physical
                              ? 'JMBG'
                              : '/'}
                        :{' '}
                        <span style={{ fontWeight: 'bold' }}>
                            {client?.entityType === EntityType.Legal
                                ? (client.taxId ?? '/')
                                : client?.entityType === EntityType.Physical
                                  ? (client.ucin ?? '/')
                                  : '/'}
                        </span>
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6, lg: 3 }}>
                    <Typography variant="body1" className="info-text">
                        Uloga klijenta:{' '}
                        <span style={{ fontWeight: 'bold' }}>
                            {client?.clientType ? ClientTypeSR[client.clientType] : '/'}
                        </span>
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6, lg: 3 }}>
                    <Typography variant="body1" className="info-text">
                        Tip klijenta:{' '}
                        <span style={{ fontWeight: 'bold' }}>
                            {client?.entityType ? EntityTypeSR[client.entityType] : '/'}
                        </span>
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 0, md: 0, lg: 12 }} sx={{ height: 15 }} />
                <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                    <Typography variant="body1" className="info-text">
                        Adresa:{' '}
                        {client?.address ? (
                            <a
                                href={mapsSearchUrl(client.address)}
                                target="_blank"
                                rel="noreferrer"
                                style={{ fontWeight: 'bold', color: 'inherit' }}
                            >
                                {client.address}
                            </a>
                        ) : (
                            <span style={{ fontWeight: 'bold' }}>/</span>
                        )}
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6, lg: 3 }}>
                    <Typography variant="body1" className="info-text">
                        Država: <span style={{ fontWeight: 'bold' }}>{client?.state ?? '/'}</span>
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6, lg: 3 }}>
                    <Typography variant="body1" className="info-text">
                        Grad: <span style={{ fontWeight: 'bold' }}>{client?.city}</span>
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 0, md: 0, lg: 12 }} sx={{ height: 15 }} />
                <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                    <Typography variant="body1" className="info-text">
                        Kontakt: <span style={{ fontWeight: 'bold' }}>{client?.contactInfo ?? '/'}</span>
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6, lg: 3 }}>
                    <Typography variant="body1" className="info-text">
                        Email: <span style={{ fontWeight: 'bold' }}>{client?.email ?? '/'}</span>
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6, lg: 3 }}>
                    <Typography variant="body1" className="info-text">
                        Telefon:{' '}
                        {client?.phone ? (
                            <a href={telUrl(client.phone)} style={{ fontWeight: 'bold', color: 'inherit' }}>
                                {client.phone}
                            </a>
                        ) : (
                            <span style={{ fontWeight: 'bold' }}>/</span>
                        )}
                    </Typography>
                </Grid2>
            </Grid2>
        </Box>
    );
}
